import React from 'react';

const ResultCard = ({ result, handleClickOpen }) => {
  const handleSeeMoreData = (id) => {
    handleClickOpen(id);
  };

  return (
    <div className="card">
      <div className="image">
        <img src={result.image} alt="" />
      </div>
      <div className="content">
        <h2>{result.title}</h2>
        <div className="footer">
          <div className="span">
            <span>Missing {result.missedIngredientCount} ingredients</span>
          </div>
          <div onClick={() => handleSeeMoreData(result.id)} className="btn">
            SEE MORE
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultCard;
